import { useEffect, useState } from "react"
import { TableDataV2 } from "@/components/common/Tablev2"
import { Protected } from "@/components/layout/Protected"
import { Container } from "@mui/material"
import { Loading } from "@/components/common/Loading"
import { Props } from "./Country,type"
import { CountryService } from "@/service/services/Country.service"
import { ModalCountry } from "@/components/Modal/ModalCountry/ModalCountry"
import { ModalCountryDelete } from "@/components/Modal/ModalCountryDelete/ModalCountryDelete"

export const CountryView: React.FC<Props> = (props:any): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(false);
    const [countries, setCountries] = useState<any>([]);
    const [showCountryModal, setShowCountryModal] = useState<boolean>(false);
    const [showCountryDeleteModal, setShowCountryDeleteModal] = useState<boolean>(false);
    const [actionSelected, setActionSelected] = useState<any>('');
    const [countrySelected, setCountrySelected] = useState<any>('');
    

    useEffect(() => {
        getCountries();
    }, []);

    const getCountries = async () => {
        setLoading(true);
        await CountryService.getCountries().then((data) => {
            setCountries(data.data || [])
           setLoading(false);
        });
    }

    function RecuperarData(value){
        setCountrySelected(value)
        console.log(value)
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container>
                <TableDataV2
                    title={'Países'}
                    data={countries || []}
                    header={[
                        { name: 'code', label: 'Código', filter: false, Chip: false },
                        { name: 'abbreviation', label: 'Abreviación', filter: false, Chip: false },
                        { name: 'name', label: 'Nombre', filter: false, Chip: false },
                        { name: 'language', label: 'Lenguaje', filter: false, Chip: true },
                        { name: 'coin', label: 'Moneda', filter: false, Chip: true },
                    ]}
                    actionSelect={setActionSelected}
                    setModalSave={setShowCountryModal}
                    setModalDelete={setShowCountryDeleteModal}
                    status_action
                    RecuperarData={RecuperarData}
                />
            </Container>

            { 
                showCountryModal && (
                    <ModalCountry
                        open={showCountryModal}
                        closeModal={()=>{setShowCountryModal(false)}}
                        actionSelected={actionSelected}
                        onListCountries={getCountries}
                        country={countrySelected}
                        clearState={()=>{setCountrySelected('')}}
                    />
                )
            }
            {
                actionSelected === 'delete' && (
                    <ModalCountryDelete
                        open={showCountryDeleteModal}
                        closeModal={()=>{setShowCountryDeleteModal(false)}}
                        actionSelected={actionSelected}
                        onListCountries={getCountries}
                        country={countrySelected}
                        clearState={()=>{setCountrySelected('')}}
                    />
                )
            }
        </Protected>
    )
}